import { createAction, props } from '@ngrx/store';
export const setFundChartType = createAction('[Fund Chart] Set chart type', props());
